export enum PersonalInfoGroup {
  ContactInfo = 'Name, email, phone number',
  MailingAddress = 'Mailing Address',
  DemographicInfo = 'Demographic Information',
  ProfessionalInfo = 'Professional Information',
}
